import { gql } from 'apollo-boost';

export const homeQuery = gql`
query {
  allPortfolios (
    filters: {enabled: true},
  ) {
    edges {
      cursor
      node {
        portfolioId
        name
        year
        reportDate1
        reportDate2
        reportDate3
        reportDate4
        reportDate6
        timelineDays1
        timelineFrom1
        timelineDays2
        timelineFrom2
        timelineDays3
        timelineFrom3
        timelineDays4
        timelineFrom4
        timelineDays6
        timelineFrom6
        status
        mainPortfolioId
        funder {
          logoFileUrl
        }
        relationshipManager {
          firstName
          lastName
          email
        }
        relationshipManagerId
        investments(filters: {enabled: true}) {
          edges {
            node {
              dbId
              enabled
              status
              cashAmount
              goodsAmount
              volunteerismAmount
              servicesAmount
              message
              programNameByDonor
              externalId
              relationshipManagerId
              grantee {
                dbId
                name
                logoFileUrl
              }
              invitation {
                edges {
                  node {
                    updatedAt
                    createdAt
                    notificationDt
                    organization
                    firstName
                    lastName
                    email
                  }
                }
              }
              allocations(filters: {enabled: true}) {
                edges {
                  node {
                    dbId
                    amount
                    updatedAt
                    createdAt
                    tier
                    tasks {
                      edges {
                        node {
                          taskType
                          dueDate
                          status
                        }
                      }
                    }
                    report {
                      name
                      stage
                      status
                      serviceName
                      logoFileUrl
                      primaryInterventionType
                      costCurrentDirectCash
                      costCurrentDirectInKind
                      costCurrentIndirectCash
                      costCurrentIndirectInKind
                      costInitialDirectCash
                      costInitialDirectInKind
                      costInitialIndirectCash
                      costInitialIndirectInKind
                      program {
                        name
                        logoFileUrl
                        manager {
                          firstName
                          lastName
                          email
                        }
                      }
                      results  {
                        edges {
                          node {
                            forecastCurrent
                            indicator {
                              name
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`;
